<template>
  <b-card header-tag="header" class="m-3" no-body>
    <template #header>
      <header-sagres titulo="Filas de PCM" />
    </template>
    <b-card-body>
      <b-row class="d-flex justify-content-between align-items-stretch">
        <b-col
          cols="12"
          md="2"
          class="d-flex flex-column justify-content-center align-items-center"
        >
          <b-card class="mb-3 filtro-card" body-class="p-3">
            <div class="font-weight-bold mb-2 text-secondary filtro-titulo">
              Filtro
            </div>
            <b-form-group label="Ano" label-for="ano-radio">
              <b-form-radio-group
                id="ano-radio"
                v-model="selectedAno"
                :options="[anoCorrente, anoAnterior]"
                name="ano-options"
                buttons
                button-variant="secondary"
                @input="filtroDirty = true"
              ></b-form-radio-group>
            </b-form-group>
            <div class="meses d-flex flex-column">
              <b-form-group
                :label="labelMesInicial"
                label-for="mes-inicial-input"
              >
                <div class="d-flex">
                  <b-form-input
                    id="mes-inicial-input"
                    v-model="mesInicial"
                    @input="ajustarRadioInicial"
                    type="range"
                    min="1"
                    max="14"
                    variant="secondary"
                  ></b-form-input>
                </div>
              </b-form-group>

              <b-form-group
                :label="labelMesCorrente"
                label-for="mes-corrente-input"
              >
                <div class="d-flex">
                  <b-form-input
                    id="mes-corrente-input"
                    v-model="mesCorrente"
                    @input="ajustarRadioCorrente"
                    type="range"
                    min="1"
                    max="14"
                    variant="secondary"
                  ></b-form-input>
                </div>
              </b-form-group>
            </div>
            <b-button
              variant="secondary"
              :disabled="+mesInicial > +mesCorrente"
              @click="carregarFila"
            >
              Carregar Fila
            </b-button>
          </b-card>
        </b-col>
        <b-col
          v-if="!filtroDirty"
          cols="12"
          md="3"
          class="d-flex flex-column justify-content-start"
        >
          <h2 class="text-secondary">
            Processadas
          </h2>

          <div>
            <div v-for="item in arrayProcessadas" :key="item.id">
              <span>{{item.titulo}}</span>
              <b-progress
                :value="item.qtdCumprida"
                :max="item.qtdMaxima"
                variant="secondary"
                class="mb-2"
              >
              </b-progress>
            </div>
          </div>
        </b-col>
        <b-col v-if="!filtroDirty" cols="12" md="7" class="d-flex flex-column justify-content-start">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <h2 class="text-secondary mb-0">
              Fila de processos
            </h2>
            <b-button
              variant="outline-secondary"
              size="sm"
              :disabled="tableBusy"
              aria-label="Atualizar fila de processos"
              title="Atualizar fila de processos"
              @click="carregarFila"
            >
              <font-awesome-icon icon="sync" :spin="tableBusy" />
              Atualizar
            </b-button>
          </div>
          <b-table
            id="filaPcmTable"
            :fields="fields"
            :items="filaRetorno.fila"
            :busy="tableBusy"
            :current-page="currentPage"
            :per-page="5"
            hover
            no-border-collapse
            striped
            stacked="xl"
            show-empty
          >
            <template #empty>
              <span>Não foram encontrados dados.</span>
            </template>
            <template #table-busy>
              <div class="text-center text-dark">
                <b-spinner class="align-middle" />
                <strong class="loading-text">Carregando...</strong>
              </div>
            </template>
          </b-table>
          <table-pagination
            v-if="totalRows > 5"
            :total-rows="totalRows"
            :per-page="5"
            @pageChange="pageChange"
          />
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script lang="ts">
import HeaderSagres from "@/components/shared/HeaderSagres.vue";
import pcmService from "@/services/entregas/pcmService";
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";
import { RetornoFilaPCM } from "@/types/entregas/pcm/retorno-fila-pcm";
import { TableField } from "@/types/table-field";
import { fieldsDashboard } from "@/types/entregas/pcm/fields-dashboard";
import TablePagination from "@/components/atos-pessoal/TablePagination.vue";

const CompProps = Vue.extend({
  name: "DashboardFilas",
  components: {
    HeaderSagres,
    TablePagination,
  },
});

interface Progresso {
  descricao: string;
  qtdMaxima: number;
  qtdCumprida: number;
}

@Component
export default class DashboardFilas extends mixins(UtilsTS, CompProps) {
  anoCorrente: number = new Date().getFullYear();
  anoAnterior: number = this.anoCorrente - 1;
  selectedAno: number = this.anoCorrente;
  mesCorrente: number = new Date().getMonth();
  mesInicial: number = this.mesCorrente; //this.mesCorrente > 1 ? this.mesCorrente - 1 : 1;
  filaRetorno = new RetornoFilaPCM(this.selectedAno, this.mesInicial, this.mesCorrente);
  filtroDirty = false;
  totalRows = 0;
  currentPage = 1;
  tableBusy = false;

  fields: TableField[] = [...fieldsDashboard];
  listaProgresso: Progresso[] = [];

  get labelMesInicial(): string {
    return `Mês Inicial (${this.mesInicial})`;
  }

  get labelMesCorrente(): string {
    return `Mês Corrente (${this.mesCorrente})`;
  }

  get arrayProcessadas(): any[] {
    return this.filaRetorno.obrigadas.map(p => {
      const qtdCumprida = this.filaRetorno.processadas.find(o => o.id_sistema === p.id_sistema)?.qtd || 0;
      return {
        id: p.id_sistema,
        titulo: `${p.id_sistema} - ${p.ds_sistema} (${qtdCumprida}/${p.qtd})`,
        qtdMaxima: p.qtd,
        qtdCumprida: qtdCumprida
      };
    }).sort((a, b) => a.id - b.id);
  }

  async created(): Promise<void> {
    //ajusta mes/ano para janeiro
  if(this.mesCorrente === 0) {
    this.mesCorrente = 14;
    this.mesInicial = 12;
    this.selectedAno = this.anoAnterior;
  }

    await this.carregarFila();
  }


  async carregarFila(): Promise<void> {
    try {
      this.tableBusy = true;
      // Lógica para carregar a fila de PCM dos meses corrente e passado
      // Exemplo:
      const retorno = await pcmService.carregarFilaPcm(
        this.selectedAno,
        this.mesInicial,
        this.mesCorrente
      );
      this.filaRetorno = retorno;
      this.totalRows = this.filaRetorno.fila.length;

      const ultimaPagina = Math.max(Math.ceil(this.totalRows / 5), 1);
      if (this.currentPage > ultimaPagina) {
        this.currentPage = ultimaPagina;
      }

      //console.log("Fila PCM corrente:", this.filaRetorno);
    } catch (error: unknown) {
      this.tratarError(error);
    } finally {
      this.tableBusy = false;
      this.filtroDirty = false;
    }
  }

  pageChange(page: number) {
    this.currentPage = page;
  }

  calcularQtdMaxima(
    mesInicial,
    mesFinal,
    qtdProcessada: number,
    qtdTotal: number
  ): string {
    let dif = Number(mesFinal) - Number(mesInicial);

    if (dif === 0) {
      return `${qtdProcessada}/${qtdTotal}`;
    }

    return `${qtdProcessada}/${qtdTotal * dif}`;
  }

  ajustarRadioInicial() {
    this.filtroDirty = true;
    if (+this.mesInicial > +this.mesCorrente) {
      this.mesCorrente = this.mesInicial;
    }
  }

  ajustarRadioCorrente() {
    this.filtroDirty = true;
    if (+this.mesCorrente < +this.mesInicial) {
      this.mesInicial = this.mesCorrente;
    }
  }
}
</script>

<style scoped>
input[type="range"]::-webkit-slider-thumb {
  background: #888; /* cinza */
}
input[type="range"]::-moz-range-thumb {
  background: #888;
}
input[type="range"]::-ms-thumb {
  background: #888;
}

.filtro-card {
  background: #f8f9fa;
  border: 2px solid #dee2e6;
  border-radius: 0.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
}
.filtro-titulo {
  font-size: 1.1rem;
  letter-spacing: 1px;
}
</style>
